import { render, staticRenderFns } from "./PainelPagamentosMensais.vue?vue&type=template&id=ad180f20"
import script from "./PainelPagamentosMensais.vue?vue&type=script&lang=js"
export * from "./PainelPagamentosMensais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports